import { GriffelStyle } from '@fluentui/react-components';

const fluid = (): GriffelStyle => ({ width: '100%' });

export const slider = {
  fluid,
};
